import { HGATE_INCLUDED } from '../../../../../../shared/env';

import { AgreementsEn } from './AgreementsEn';
import { AgreementsKo } from './AgreementsKo';

export const Agreements = HGATE_INCLUDED ? AgreementsKo : AgreementsEn;
